import {
  BrowserRouter as Router,
  Routes,
  Route,
  Outlet,
  Navigate,
} from "react-router-dom";
import LandingPage from "./pages/LandingPage";
import UserDashboard from "./pages/UserDashboard";
import SignIn from "./pages/SignIn";
import Pricing from "./pages/Pricing";
import Plans from "./pages/Plans";
import Rooms from "./pages/Rooms";
import SignUp from "./pages/SignUp";
import SecureComponent from "./components/SecureComponent";
import RequireAuth from "@auth-kit/react-router/RequireAuth";
import Locations from "./pages/Locations";
import Dashboard from "./pages/Dashboard";
import CompanyAdminDashboard from "./pages/CompanyAdminDashboard";
import About from "./pages/About";
import Contact from "./pages/Contact";
import Profile from "./pages/Profile";
import MyCalendar from "./pages/MyCalendar";
import useAuthUser from "react-auth-kit/hooks/useAuthUser";
import useIsAuthenticated from "react-auth-kit/hooks/useIsAuthenticated";
import NotFound from "./pages/404";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";

export const App = () => {
  const RoleAccess = ({ roles = [] }) => {
    const user = useAuthUser();
    // console.log(user)
    // console.log(roles)
    return !roles.length || roles.includes(user?.typeId) ? (
      <Outlet />
    ) : (
      <Navigate
        to='/not-found'
        replace
      />
    );
  };

  /**
   * HomePage component - Conditionally renders LandingPage or UserDashboard
   * based on user authentication status
   */
  const HomePage = () => {
    const isAuthenticated = useIsAuthenticated();

    if (isAuthenticated()) {
      return <UserDashboard />;
    } else {
      return <LandingPage />;
    }
  };

  return (
    <Router>
      <Routes>
        <Route
          path='/'
          element={<HomePage />}
        />
        <Route
          path='/sign-in'
          element={<SignIn />}
        />
        <Route
          path='/sign-up'
          element={<SignUp />}
        />
        <Route
          path='/forgot-password'
          element={<ForgotPassword />}
        />
        <Route
          path='/reset-password/:token'
          element={<ResetPassword />}
        />
        <Route
          path='/reset-password'
          element={<ResetPassword />}
        />
        {/* Add a new route that includes the token parameter */}
        <Route element={<SignIn />} />
        <Route
          path='/pricing'
          element={<Pricing />}
        />
        <Route
          path='/plans'
          element={<Plans />}
        />
        <Route
          path='/locations'
          element={<Locations />}
        />
        <Route
          path='/rooms'
          element={<Rooms />}
        />
        <Route
          path='/about'
          element={<About />}
        />
        <Route
          path='/contact-us'
          element={<Contact />}
        />
        <Route
          path='/profile'
          element={
            <RequireAuth fallbackPath={"/sign-in"}>
              <Profile />
            </RequireAuth>
          }
        />
        <Route
          path='/my-calendar'
          element={
            <RequireAuth fallbackPath={"/sign-in"}>
              <MyCalendar />
            </RequireAuth>
          }
        />
        <Route
          path={"/secure"}
          element={
            <RequireAuth fallbackPath={"/sign-in"}>
              <SecureComponent />
            </RequireAuth>
          }
        />
        {/* Super Admin Dashboard - for Employees and Admins */}
        <Route element={<RoleAccess roles={[3, 4]} />}>
          <Route
            path='/dashboard'
            element={
              <RequireAuth fallbackPath={"/sign-in"}>
                <Dashboard />
              </RequireAuth>
            }
          />
        </Route>
        {/* Company Admin Dashboard - for Company Admins only */}
        <Route element={<RoleAccess roles={[2]} />}>
          <Route
            path='/company-dashboard'
            element={
              <RequireAuth fallbackPath={"/sign-in"}>
                <CompanyAdminDashboard />
              </RequireAuth>
            }
          />
        </Route>
        <Route
          path='*'
          element={<NotFound />}
        />
      </Routes>
    </Router>
  );
};
